import { Alert, Typography } from '@mui/material';
export type Mode = 'warning' | 'danger' | 'info' | 'success' | 'primary'| 'secondary' | 'light' | 'dark'  ;
function ErrorSummary({ errors, showEverything =false, mode ="warning" as Mode }) {

    showEverything = false; //to be removed when labels are fixed
    return (((showEverything && Object.keys(errors).length>0) || errors?.summary!=null) &&
    <Alert severity='warning'>
      {!showEverything && errors.summary?.map((error, index) => (
        <Typography key={index} variant="body2" color="inherit">
          {error}
        </Typography>
      ))}
    </Alert>
)}

export default ErrorSummary;